const DEBUG = false;

const DIM = 104

const PRIO_QUEUE_LENGTH = 10;

const N = 8
const M = 8

export {DEBUG, N, M, PRIO_QUEUE_LENGTH, DIM}